// extracted by mini-css-extract-plugin
export default {"container":"AuthAppInfo_container__btXZD","title":"AuthAppInfo_title__3fGRw","heading":"AuthAppInfo_heading__vnpLu","sub-heading":"AuthAppInfo_sub-heading__F98mF"};